import React from "react";

function ModalSkeleton() {
  const skeletonBars = Array.from({ length: 3 });

  return (
    <div className="flex flex-col gap-2 p-1 mt-4">
      <div className="h-6 w-2/3 animateSkl"></div>
      <div className="h-6 w-1/3 animateSkl"></div>
      {skeletonBars.map((_, i) => (
        <div key={i} className="h-14 gap-3 flex items-center ">
            <div className="w-1/2 h-full animateSkl"></div>
            <div className="w-1/2 h-full animateSkl"></div>
        </div>
      ))}
    </div>
  );
}

export default ModalSkeleton;
